import BaseAPI, { querySuffix } from "./BaseAPI";
import { intakeTraceRoute } from "../routes";

export default class IntakeTraceAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, intakeTraceRoute, "intake-trace");
    }

    async Search(params = {}) {
        return (await this._request("get", this._url(`/search${querySuffix(params)}`))) ?? [];
    }
}
